@if (props.label) {
  <apm-section-title
    [title]="props.label"
    matTooltip="{{ hasDatasheetMoreDetailsPermission ? field.key : '' }}"
  ></apm-section-title>
}
@for (image of field.fieldGroup; track image.key) {
  <div class="d-flex flex-column mb-2">
    <span>{{ image.props?.label }}</span>
    <formly-field [field]="image"></formly-field>
  </div>
}
